import { fromJS } from 'immutable'
import * as actions from './SparePartImagesActions'

const initialSparePartImagesState = fromJS({
	sparePartImage: null,
	imagesByCodeSearch: [],
	isSavingImageContainer: false,
	isDeletingSparePartImage: false,
	isGetingImageContainer: false,
	isUploadingImage: false
})

const SparePartImagesReducer = (state = initialSparePartImagesState, action) => {
	switch (action.type) {
		case actions.SET_SPARE_PART_IMAGE: {
			return state.merge({
				sparePartImage: action.data
			})
		}
		case actions.SET_IMAGES_BY_CODE_SEACH: {
			return state.merge({
				imagesByCodeSearch: action.data
			})
		}
		case actions.IS_SAVING_IMAGE_CONTAINER: {
			return state.merge({
				isSavingImageContainer: action.status
			})
		}
		case actions.IS_DELETING_SPARE_PART_IMAGE: {
			return state.merge({
				isDeletingSparePartImage: action.status
			})
		}
		case actions.IS_GETING_IMAGE_CONTAINER: {
			return state.merge({
				isGetingImageContainer: action.status
			})
		}
		case actions.IS_UPLOADING_SPARE_PART_IMAGE: {
			return state.merge({
				isUploadingImage: action.status
			})
		}
		default:
			return state
	}
}

export default SparePartImagesReducer
